<i18n>
{
    "ru": {
        "post_description": "Здесь будут ваши посты – всё, чем вы решите поделиться с сообществом: заметки, размышления, интересные ссылки и т.п.",
        "post_caption": "Не забывайте, что к каждой записи вы можете прикрепить фото и видео!",
        "articles_description": "Здесь будут ваши статьи – всё, чем вы решите поделиться с сообществом: заметки, размышления, интересные ссылки и т.п.",
        "articles_caption": "Не забывайте, что к каждой записи вы можете прикрепить фото и видео!",
        "news_description": "Здесь будут ваши новости – всё, чем вы решите поделиться с сообществом: заметки, размышления, интересные ссылки и т.п.",
        "news_caption": "Не забывайте, что к каждой записи вы можете прикрепить фото и видео!",
        "comment_description": "Здесь будут собраны комментарии, которые вы оставляете на страницах Aromo.",
        "comment_caption": "Вы можете прокомментировать записи, новости, статьи, отзывы и отвечать на комментарии других пользователей.",
        "review_description": "Здесь будут собраны отзывы об ароматах, брендах и магазинах, которые вы оставляете на страницах Aromo.",
        "review_caption": "Чтобы написать отзыв, перейдите на нужную страницу и воспользуйтесь полем для комментария или опцией «Оценить».",
        "shop_description": " ",
        "shop_caption": "Отзывов и комментариев пока нет.",

        "male_write": "написал",
        "female_write": "написала",
        "male_write": "написал",
        "female_write": "написала",

        "female_post": "написала",
        "male_post": "написал",

        "review_caption_stranger": "пока не {writeAction} ни одного отзыва",
        "comment_caption_stranger": "пока не {writeAction} ни одного комментария"
    }
}
</i18n>

<template>
    <div class="empty-posts-plug">
        <div class="empty-posts-plug__picture-wrapper">
            <img class="empty-posts-plug__picture"
                v-lazy-load data-src="/img/noresults.jpg"
                alt="" />
        </div>

        <template v-if="isStranger">
            <div v-if="dataType === 'review'" class="empty-posts-plug__description">
                {{userName}} {{ $t(`${dataType}_caption_stranger`, {writeAction: $t(gender + '_write')  }) }}
            </div>
            <div v-if="dataType === 'comment'" class="empty-posts-plug__description">
                {{userName}} {{ $t(`${dataType}_caption_stranger`, {writeAction: $t(gender + '_post')  }) }}
            </div>
        </template>

        <template v-else>
            <div class="empty-posts-plug__description">
                {{ $t(`${dataType}_description`) }}
            </div>
            <div class="empty-posts-plug__caption">
                {{ $t(`${dataType}_caption`) }}
            </div>
        </template>

    </div>
</template>

<script>
export default {
    name: 'BlockEmptyPosts',
    props: {
        dataType: {
            type: String,
            default: ''
        },
        isStranger: {
            type: Boolean,
            default: false
        },
        userName: {
            type: String,
            default: ''
        },
        gender: {
            type: String,
            default: 'male'
        }
    }
}
</script>

<style lang="less">
.empty-posts-plug {
    display: flex;
    flex-direction: column;
    align-items: center;

    text-align: center;
    margin-bottom: rem(32);

    @{mobile} & {
        .page-padding();
    }

    &__description {
        font-weight: 500;

        @{desktop} & {
            max-width: 66%;
        }
    }

    &__caption {
        margin-top: rem(12);

        @{desktop} & {
            max-width: 66%;
        }
    }

    &__picture{
        max-width: rem(335);
        margin: 0 auto rem(20);
        display: block;
    }
}
</style>
